<template>
  <div>
    <b-row class="d-flex align-items-center">
      <b-col cols="8">
        <h1 class="font-weight-bolder mb-0">Price Promotion Builder</h1>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" class="text-right">
        <b-button
          @click="$router.push('/promotions/price-promotions')"
          variant="outline-secondary"
          class="mr-1"
        >
          Cancel
        </b-button>
        <b-button
          @click="
            handleCreatePromotion({ status: 'inactive', action: 'draft' })
          "
          variant="outline-secondary"
          class="mr-1"
          :disabled="loadingAction === 'draft' && loadingCreatePromotion"
          style="min-width: 136px"
        >
          Save as Draft
        </b-button>

        <b-button
          :disabled="loadingAction === 'publish' && loadingCreatePromotion"
          @click="
            handleCreatePromotion({ status: 'active', action: 'publish' })
          "
          variant="primary"
          style="min-width: 172px"
          class="mr-1"
        >
          Publish Promotion
        </b-button>
        <b-button
          :disabled="loadingAction === 'now' && loadingCreatePromotion"
          @click="
            handleCreatePromotion({
              status: 'active',
              isNow: true,
              action: 'now',
            })
          "
          variant="primary"
          style="min-width: 172px"
        >
          Publish Promotion Now
        </b-button>
      </b-col>
    </b-row>

    <b-row class="mt-2">
      <b-col cols="12">
        <b-card>
          <b-row>
            <b-col cols="12">
              <p class="font-weight-bold mb-0">
                Promotion Name (Internal Description)
              </p>
              <b-form-input
                placeholder="June 100% Deposit Bonus"
                v-model="form.name"
                type="text"
              />
            </b-col>

            <b-col cols="12" class="mt-1">
              <b-form-group>
                <p class="font-weight-bold mb-0">
                  Description (Customer Description)
                </p>
                <b-form-textarea
                  v-model="form.description"
                  placeholder="Short description for admins..."
                  rows="3"
                ></b-form-textarea>
              </b-form-group>
            </b-col>

            <b-col cols="12">
              <p class="font-weight-bold mb-0">More Info</p>
              <vue2-tinymce-editor
                :key="'additionalInfo'"
                id="additionalInfo"
                v-model="form.additionalInfo"
                :options="{ ...editorOptions }"
              />
            </b-col>

            <b-col cols="12">
              <b-row>
                <b-col cols="6">
                  <b-row>
                    <b-col cols="6">
                      <p class="font-weight-bold mb-0">Start Date / Time</p>
                      <flat-pickr
                        id="startDate"
                        v-model="form.startTime"
                        class="form-control"
                        :config="configDate"
                        placeholder="dd/mm/yyyy hh:mm"
                      />
                    </b-col>
                    <b-col cols="6">
                      <p class="font-weight-bold mb-0">End Date / Time</p>
                      <flat-pickr
                        id="endDate"
                        v-model="form.endTime"
                        class="form-control"
                        :config="configDate"
                        placeholder="dd/mm/yyyy hh:mm"
                      />
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-card>

        <b-row>
          <b-col>
            <b-tabs v-model="activeTab">
              <b-tab title="Racing">
                <b-card>
                  <h5 class="font-weight-bold">Race Selection</h5>
                  <b-form-group label="Search Races">
                    <div class="position-relative">
                      <b-input-group>
                        <b-input-group-prepend is-text>
                          <feather-icon icon="SearchIcon" />
                        </b-input-group-prepend>
                        <b-form-input
                          v-model="search"
                          placeholder="Search by race name, venue, or date..."
                          @focus="showDropdown = true"
                          @input="handleSearch"
                        ></b-form-input>
                        <b-input-group-append>
                          <b-button variant="outline-secondary"
                            >Search</b-button
                          >
                        </b-input-group-append>
                      </b-input-group>
                      <transition name="fade">
                        <div
                          v-if="showDropdown && filteredMeeting.length"
                          class="dropdown-list shadow-sm border rounded bg-white mt-1"
                        >
                          <b-list-group
                            flush
                            style="max-height: 300px; overflow-y: auto"
                          >
                            <b-list-group-item
                              v-for="(meeting, i) in filteredMeeting"
                              :key="i"
                              class="d-flex justify-content-between align-items-center list-item"
                              @click="selectMeeting(meeting)"
                              variant="light"
                            >
                              <div>
                                <div class="font-weight-bold">
                                  {{ meeting.venueName }}
                                </div>
                                <small class="text-muted">{{
                                  format(
                                    new Date(meeting.meetingDate),
                                    "LLL, dd yyyy HH:mm"
                                  )
                                }}</small>
                              </div>
                              <b-badge
                                :variant="
                                  variantTypeRacing(meeting.meetingType)
                                "
                                >{{ meeting.meetingType }}</b-badge
                              >
                            </b-list-group-item>
                          </b-list-group>
                        </div>
                      </transition>
                    </div>
                  </b-form-group>

                  <b-row>
                    <b-col md="6">
                      <b-form-group label="Browse Calendar">
                        <flat-pickr
                          v-model="selectedDate"
                          class="form-control"
                          :config="configDateMeeting"
                          placeholder="dd/mm/yyyy"
                        />
                      </b-form-group>
                    </b-col>
                    <b-col md="6">
                      <b-form-group label="Selected Date">
                        <b-form-input
                          readonly
                          class="font-weight-bolder"
                          :value="
                            selectedDate
                              ? format(
                                  new Date(selectedDate),
                                  'EEEE dd LLLL yyyy'
                                )
                              : 'No date selected'
                          "
                        ></b-form-input>
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <!-- Racing Code -->
                  <b-form-group
                    label="Racing Code* (Leave blank to show all codes)"
                  >
                    <b-form-select
                      v-model="filter.racingCode"
                      :options="racingCodes"
                    />
                  </b-form-group>

                  <!-- Meetings & Races -->
                  <b-row>
                    <b-col md="6">
                      <p class="font-weight-bold">Meetings</p>
                      <b-card
                        v-if="!selectedMeeting.length"
                        border-variant="secondary"
                        bg-variant="light"
                        class="text-muted text-center py-5"
                      >
                        Select a date to view meetings
                      </b-card>
                      <b-card
                        no-body
                        v-else
                        border-variant="secondary"
                        bg-variant="light"
                        class="text-center"
                        style="max-height: 200px; overflow-y: auto"
                      >
                        <div
                          v-for="m in selectedMeeting"
                          :key="m.meetingId"
                          class="meeting-item"
                          :class="{
                            'meeting-item-active':
                              meetingActive &&
                              meetingActive.meetingId === m.meetingId,
                          }"
                          @click="getRacesInMeeting(m)"
                        >
                          <div
                            class="d-flex align-items-center"
                            style="gap: 8px"
                          >
                            <span class="font-weight-bolder">{{
                              m.venueName
                            }}</span>
                            <span class="text-muted" style="font-size: 12px"
                              >{{ m.state }}, {{ m.country }}</span
                            >
                          </div>
                          <b-badge
                            :variant="variantTypeRacing(m.meetingType)"
                            class="ml-2"
                            >{{ m.meetingType }}</b-badge
                          >
                        </div>
                      </b-card>
                    </b-col>
                    <b-col md="6">
                      <p class="font-weight-bold">Races</p>
                      <b-card
                        v-if="!raceInMeeting.length"
                        border-variant="secondary"
                        bg-variant="light"
                        class="text-muted text-center py-5"
                      >
                        Select a meeting to view races
                      </b-card>
                      <b-card
                        no-body
                        v-else
                        border-variant="secondary"
                        bg-variant="light"
                        class="p-1"
                      >
                        <b-form-radio-group
                          v-model="selectedRace"
                          name="race-options"
                          style="gap: 8px"
                        >
                          <b-form-radio
                            v-for="race in raceInMeeting"
                            :key="race.value"
                            :value="race"
                            class="d-flex align-items-center"
                          >
                            <span class="text-body">{{ race.text }}</span>
                          </b-form-radio>
                        </b-form-radio-group>
                      </b-card>
                    </b-col>
                  </b-row>

                  <p class="font-weight-bold">Select Horse (Selected Horse)</p>
                  <b-card
                    v-if="!runners.length"
                    class="mt-1"
                    border-variant="secondary"
                    bg-variant="light"
                  >
                    <div class="text-muted">
                      No horse selected<br />
                      Select a race to view runners
                    </div>
                  </b-card>

                  <b-card
                    no-body
                    v-else
                    border-variant="secondary"
                    bg-variant="light"
                    class="p-1"
                  >
                    <div v-if="selectedRunner">
                      <p class="text-muted font-weight-bolder">
                        {{ selectedRunner.runnerName }} ({{
                          selectedRunner.runnerNo
                        }})
                        <span class="font-weight-normal"
                          >Original Odds:
                          {{
                            formatCurrencyBuiltInFunc(
                              Number(
                                form.marketType === "win"
                                  ? selectedRunner.place
                                  : selectedRunner.placePrice
                              ) || 0
                            )
                          }}</span
                        >
                      </p>
                    </div>
                    <b-form-radio-group
                      v-model="selectedRunner"
                      class="d-flex flex-column"
                      style="gap: 8px"
                    >
                      <b-form-radio
                        v-for="(runner, idx) in runners"
                        :key="runner.value"
                        :value="runner"
                        class="w-100 d-flex align-items-center justify-content-between radio-runner"
                      >
                        <span class="text-body font-weight-bolder"
                          >{{ idx + 1 }}.{{ runner.runnerName }} ({{
                            runner.runnerNo
                          }})</span
                        >
                        <span class="text-muted">
                          Original:
                          {{
                            formatCurrencyBuiltInFunc(
                              Number(
                                form.marketType === "win"
                                  ? runner.place
                                  : runner.placeWin
                              ) || 0
                            )
                          }}
                        </span>
                      </b-form-radio>
                    </b-form-radio-group>
                  </b-card>
                </b-card>

                <b-card class="mb-1 shadow-sm border-0">
                  <h5 class="font-weight-semibold">
                    Racing Market & Pricing Configuration
                  </h5>

                  <!-- Market Type -->
                  <b-form-group label="Market Type">
                    <b-form-select
                      v-model="form.marketType"
                      :options="marketTypesRacing"
                    ></b-form-select>
                  </b-form-group>

                  <!-- Selected Race -->
                  <b-form-group label="Selected Race">
                    <b-form-input
                      :value="selectedRace ? selectedRace.text : ''"
                      placeholder="Select a race from above"
                      readonly
                      class="bg-light"
                    ></b-form-input>
                  </b-form-group>

                  <!-- Customer Limit -->

                  <b-row v-if="selectedRunner">
                    <b-col md="6">
                      <b-form-group label="Horse Name">
                        <b-form-input
                          :value="selectedRunner.runnerName"
                          readonly
                        />
                      </b-form-group>
                    </b-col>

                    <b-col md="6">
                      <b-form-group label="Original Odds">
                        <b-input-group prepend="$">
                          <b-form-input
                            :v-model="
                              form.marketType === 'win'
                                ? selectedRunner.place
                                : selectedRunner.placePrice
                            "
                            readonly
                          />
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <b-form-group
                    v-if="selectedRunner"
                    label="Promotional Odds"
                    description="Special price for this horse"
                  >
                    <b-input-group prepend="$">
                      <b-form-input
                        type="number"
                        v-model="form.discountValue"
                      />
                    </b-input-group>
                  </b-form-group>

                  <b-row v-if="selectedRunner">
                    <b-col md="6">
                      <b-form-group
                        label="Max Stake per Bet*"
                        description="Maximum stake allowed per bet on this promotion"
                      >
                        <b-input-group prepend="$">
                          <b-form-input v-model="form.maxDiscount" />
                        </b-input-group>
                      </b-form-group>
                    </b-col>

                    <b-col cols="6">
                      <b-form-group label="Maximum Exposure">
                        <b-input-group size="md" prepend="$" append=".00">
                          <b-form-input
                            v-model="form.globalExposureLimit"
                            type="number"
                          ></b-form-input>
                        </b-input-group>
                        <small class="text-muted"
                          >Total liability cap for this promotion</small
                        >
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-form-group label="Customer Limit">
                    <b-form-select
                      v-model="form.globalLimit"
                      :options="customerLimitOptions"
                      class="rounded"
                    ></b-form-select>
                  </b-form-group>
                  <b-form-checkbox>
                    Specials cannot be boosted
                  </b-form-checkbox>
                </b-card>
              </b-tab>

              <b-tab title="Sport">
                <b-card>
                  <h5 class="font-weight-bold">Sport Selection</h5>
                  <span class="text-muted"
                    >Sport selection interface will be added here</span
                  >
                </b-card>

                <b-card>
                  <h5 class="font-weight-bold">
                    Sport Market & Pricing Configuration
                  </h5>
                  <b-form-group label="Sport">
                    <b-form-select
                      v-model="selectedSport.sport"
                      :options="sports"
                    />
                  </b-form-group>
                  <b-form-group label="League/Competition">
                    <b-form-select
                      v-model="selectedSport.league"
                      :options="leagues"
                    />
                  </b-form-group>
                  <b-form-group label="Event">
                    <b-form-select
                      v-model="selectedSport.event"
                      :options="events"
                    />
                  </b-form-group>
                  <b-form-group label="Market">
                    <b-form-select v-model="selectedSport.market">
                      <b-form-select-option
                        v-for="item in markets"
                        :key="item.id"
                        :value="item"
                      >
                        {{ item.text }}
                      </b-form-select-option>
                    </b-form-select>
                  </b-form-group>
                  <b-form-group label="Selection">
                    <b-form-select v-model="selectedSport.selection">
                      <b-form-select-option
                        v-for="item in selections"
                        :key="item.id"
                        :value="item"
                      >
                        {{ item.text }}
                      </b-form-select-option>
                    </b-form-select>
                  </b-form-group>
                  <b-form-group label="Market Type">
                    <b-form-select
                      v-model="form.marketType"
                      :options="marketTypesSport"
                    />
                  </b-form-group>

                  <b-row>
                    <b-col cols="12" v-if="selectedSport.selection">
                      <b-form-group
                        label="Selection 1 (e.g. QLD)"
                        for="selection-1"
                      >
                        <b-form-input
                          v-model="selectedSport.selection.text"
                          id="selection-1"
                          readonly
                          placeholder="Selection Name"
                        ></b-form-input>
                      </b-form-group>
                      <b-form-group>
                        <b-input-group prepend="Original Odds $">
                          <b-form-input
                            type="number"
                            readonly
                            v-model="selectedSport.selection.originalWinPrice"
                          />
                        </b-input-group>
                      </b-form-group>
                      <b-form-group>
                        <b-input-group prepend="Promo Odds $">
                          <b-form-input
                            type="number"
                            v-model="form.discountValue"
                          />
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <b-form-group label="Maximum Exposure">
                    <b-input-group size="md" prepend="$" append=".00">
                      <b-form-input
                        v-model="form.globalExposureLimit"
                        type="number"
                      ></b-form-input>
                    </b-input-group>
                    <small class="text-muted"
                      >Total liability cap for this promotion</small
                    >
                  </b-form-group>
                  <b-form-group label="Customer Limit">
                    <b-form-select
                      v-model="form.globalLimit"
                      :options="customerLimitOptions"
                      class="rounded"
                    ></b-form-select>
                  </b-form-group>
                  <b-form-checkbox>
                    Specials cannot be boosted
                  </b-form-checkbox>
                </b-card>
              </b-tab>
            </b-tabs>
          </b-col>
        </b-row>

        <b-card class="mb-2">
          <b-row>
            <b-col>
              <div class="d-flex align-items-center mb-1">
                <p class="form-label mb-0 me-2 mr-1">Selected</p>
                <span
                  class="badge bg-secondary"
                  style="line-height: 10px; padding: 6px"
                  >{{ selectedRules.length }}</span
                >
              </div>
              <div
                class="border"
                style="
                  background: #f8f9fa;
                  border-radius: 5px;
                  min-height: 80px;
                  max-height: 500px;
                  overflow-y: auto;
                "
              >
                <b-col>
                  <p v-if="!selectedRules.length" class="mt-1">No selected</p>
                  <div
                    v-else
                    class="mt-1 mb-1 d-flex flex-wrap"
                    style="gap: 4px"
                  >
                    <div
                      v-for="item in selectedRules"
                      :key="item.conditionValue"
                      class="d-flex align-items-center active-position font-weight-bold"
                      style="
                        gap: 6px;
                        width: fit-content;
                        padding: 2px 6px;
                        border-radius: 5px;
                      "
                    >
                      <template v-if="item.raceId">
                        {{ item.venueName }}
                        <small
                          style="
                            width: 6px;
                            height: 6px;
                            border-radius: 100%;
                            background: white;
                          "
                        ></small>
                        {{ format(new Date(item.utcTime), "E, d MMM yyyy") }}
                        <small
                          style="
                            width: 6px;
                            height: 6px;
                            border-radius: 100%;
                            background: white;
                          "
                        ></small>
                        Race {{ item.eventNo }}: {{ item.eventName }}
                      </template>
                      <template v-else>
                        {{ item.conditionValue }}
                      </template>
                      <feather-icon
                        icon="XIcon"
                        style="color: white"
                        class="cursor-pointer"
                        @click="handleRemoveRaceItem(item)"
                      />
                    </div>
                  </div>
                </b-col>
              </div>
            </b-col>
          </b-row>
        </b-card>

        <b-card>
          <b-row>
            <b-col
              cols="12"
              class="d-flex align-items-center justify-content-between mb-1"
              ><h5 class="font-weight-bolder text-body">
                Customer Eligibility
              </h5>
              <input
                ref="fileInput"
                type="file"
                accept=".csv"
                hidden
                @change="handleFileUpload"
              />
              <b-button
                size="sm"
                variant="outline-primary"
                @click="onClickInput"
              >
                <feather-icon icon="UploadIcon" />

                CSV File Upload
              </b-button>
            </b-col>
            <b-col
              cols="12"
            >
              <div>
                <div
                  class="d-flex align-items-center mb-1 cursor-pointer"
                  style="border-bottom: 1px solid #dee2e6"
                >
                  <div
                    @click="activeTabCustomer = 'Customer Profiles'"
                    style="padding: 6px 16px"
                    :class="{
                      'active-tab': activeTabCustomer === 'Customer Profiles',
                    }"
                  >
                    Customer Profiles
                  </div>
                  <div
                    style="padding: 6px 16px; opacity: 0.45; cursor: default; user-select: none"
                    :class="{
                      'active-tab': activeTabCustomer === 'Customer Segments',
                    }"
                  >
                    Customer Segments
                  </div>
                </div>

                <b-row>
                  <b-col style="min-height: 100px">
                    <!-- Customer Profiles -->
                    <div
                      v-if="activeTabCustomer === 'Customer Profiles'"
                      class="grid-3"
                    >
                      <div
                        class="d-flex align-items-center cursor-pointer"
                        v-for="item in profiles"
                        :key="item"
                        style="
                          border: 1px solid #dee2e6;
                          border-radius: 5px;
                          gap: 10px;
                          padding: 8px 10px;
                        "
                        :style="{
                          background: selectedProfile.some((i) => i === item)
                            ? '#0D6EFD'
                            : '#f8f9fa',
                          color: selectedProfile.some((i) => i === item)
                            ? 'white'
                            : 'black',
                        }"
                        @click="handleSelectProfile(item)"
                      >
                        <div
                          class="d-flex justify-content-center align-items-center"
                          style="
                            width: 16px;
                            height: 16px;
                            border-radius: 2px;
                            border: 1px solid #dee2e6;
                          "
                          :style="{
                            background: selectedProfile.some((i) => i === item)
                              ? '#0D6EFD'
                              : 'white',
                          }"
                        >
                          <feather-icon icon="CheckIcon" style="color: white" />
                        </div>
                        {{ item }}
                      </div>
                    </div>

                    <!-- Customer Segments -->
                    <div v-else style="opacity: 0.45; cursor: default; user-select: none">
                      <draggable
                        :list="customerSegments"
                        :group="{ name: 'tag', pull: 'clone', put: false }"
                        @change="handleDrag"
                        class="d-flex flex-wrap w-100"
                        :sort="false"
                      >
                        <b-col
                          v-for="(tag, index) in customerSegments"
                          :key="index"
                          cols="6"
                          md="3"
                          style="padding: 6px"
                        >
                          <b-card
                            border-variant="secondary"
                            body-class="p-0"
                            class="mb-0"
                            style="padding: 8px; border-radius: 4px"
                            :data-item="JSON.stringify(tag)"
                            ><span>{{ tag.name }}</span></b-card
                          >
                        </b-col>
                      </draggable>
                    </div>
                  </b-col>
                </b-row>
              </div>
            </b-col>
          </b-row>

          <!-- Customer Picker Section -->
          <b-row class="mt-2">
            <b-col cols="12" class="mb-1">
              <h5 class="font-weight-bolder text-body">Customers</h5>
            </b-col>
            <b-col cols="12" md="6">
              <b-card no-body class="border" style="overflow: hidden">
                <!-- Sticky Search -->
                <div
                  class="p-1"
                  style="
                    border-bottom: 1px solid #e0e0e0;
                    position: sticky;
                    top: 0;
                    z-index: 2;
                    background: white;
                  "
                >
                  <b-form-input
                    v-model="userPickerSearch"
                    placeholder="Search by username..."
                  />
                </div>
                <!-- Scrollable User List -->
                <div
                  ref="userPickerList"
                  style="max-height: 320px; overflow-y: auto"
                  @scroll="handleUserListScroll"
                >
                  <div
                    v-if="userPickerLoading && userPickerUsers.length === 0"
                    class="text-center py-3 text-muted"
                  >
                    <b-spinner small /> Loading...
                  </div>
                  <div
                    v-else-if="
                      !userPickerLoading && userPickerUsers.length === 0
                    "
                    class="text-center py-3 text-muted"
                  >
                    No users found
                  </div>
                  <div
                    v-for="user in userPickerUsers"
                    :key="user.userId"
                    class="d-flex align-items-center px-2 py-1"
                    style="
                      border-bottom: 1px solid #f0f0f0;
                      cursor: pointer;
                      transition: background 0.15s;
                    "
                    :style="
                      isUserConfirmed(user.userId)
                        ? 'background:#f0fff4'
                        : userPickerVerifyingId === user.userId
                        ? 'background:#f8f9fa'
                        : ''
                    "
                    @click="handleSelectUser(user)"
                  >
                    <b-avatar
                      size="28"
                      :text="
                        (user.firstName ||
                          user.username ||
                          '?')[0].toUpperCase()
                      "
                      variant="light-primary"
                      class="mr-1"
                    />
                    <div style="flex: 1; min-width: 0">
                      <div
                        class="font-weight-bold text-truncate"
                        style="font-size: 13px"
                      >
                        {{ user.firstName }} {{ user.lastName }}
                      </div>
                      <div
                        class="text-muted text-truncate"
                        style="font-size: 11px"
                      >
                        {{ user.username }} &bull; {{ user.userId }}
                      </div>
                    </div>
                    <b-spinner
                      v-if="userPickerVerifyingId === user.userId"
                      small
                      class="ml-1"
                    />
                    <feather-icon
                      v-else-if="isUserConfirmed(user.userId)"
                      icon="CheckIcon"
                      size="16"
                      class="ml-1"
                      style="color: #28a745; flex-shrink: 0"
                    />
                  </div>
                  <div
                    v-if="userPickerLoading && userPickerUsers.length > 0"
                    class="text-center py-2 text-muted"
                  >
                    <b-spinner small /> Loading more...
                  </div>
                </div>
              </b-card>
            </b-col>

            <!-- Confirmed Users List -->
            <b-col cols="12" md="6">
              <b-card
                no-body
                class="border"
                style="overflow: hidden; min-height: 60px"
              >
                <div style="max-height: 362px; overflow-y: auto">
                  <div
                    v-if="confirmedUsers.length === 0"
                    class="text-center text-muted py-3"
                    style="font-size: 13px"
                  >
                    No users selected yet.
                  </div>
                  <div
                    v-for="(u, idx) in confirmedUsers"
                    :key="u.userId"
                    class="d-flex align-items-center px-2 py-1"
                    style="
                      border-bottom: 1px solid #cce5ff;
                      background: #e8f4ff;
                    "
                  >
                    <b-avatar
                      size="28"
                      :text="
                        (u.firstName || u.username || '?')[0].toUpperCase()
                      "
                      variant="light-primary"
                      class="mr-1"
                    />
                    <div style="flex: 1; min-width: 0">
                      <div
                        class="font-weight-bold text-truncate"
                        style="font-size: 13px"
                      >
                        {{ u.firstName }} {{ u.lastName }}
                      </div>
                      <div
                        class="text-muted text-truncate"
                        style="font-size: 11px"
                      >
                        {{ u.username }} &bull; {{ u.userId }}
                      </div>
                    </div>
                    <b-button
                      size="sm"
                      variant="flat-danger"
                      class="p-0 ml-1"
                      style="line-height: 1; min-width: 24px"
                      @click="removeConfirmedUser(idx)"
                    >
                      <feather-icon icon="XIcon" size="14" />
                    </b-button>
                  </div>
                </div>
              </b-card>
              <div class="mt-1 mb-1 text-right">
                <b-button
                  size="sm"
                  variant="outline-primary"
                  :disabled="confirmedUsers.length === 0"
                  @click="handleAddConfirmedUsersToSegment"
                >
                  <feather-icon icon="ArrowRightIcon" size="14" class="mr-25" />
                  Set Recurrence List Selected
                </b-button>
              </div>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="12" class="mt-1" style="margin-bottom: 5px">
              <!-- <small class="text-muted text-sm"
                            >Drag items to the table on the right to set
                            recurring issuance</small
                          > -->
            </b-col>
            <b-col>
              <draggable
                :value="selectedSegment"
                @change="handleDrag"
                @add="handleDrop"
                group="tag"
                class="w-100"
              >
                <div style="border: 1px solid #dee2e6; border-radius: 5px">
                  <p
                    style="
                      background: #f8f9fa;
                      font-weight: 800;
                      border-radius: 5px 5px 0 0;
                      padding: 8px 10px;
                      border-bottom: 1px solid #dee2e6;
                    "
                  >
                    Segment
                  </p>

                  <div
                    v-if="selectedSegment.length === 0"
                    class="d-flex align-items-center justify-content-center"
                    style="min-height: 100px"
                  >
                    <div>
                      Drag profiles or segments here to include in this
                      promotion
                    </div>
                  </div>
                  <div v-else>
                    <div
                      v-for="(item, ind) in selectedSegment"
                      :key="ind"
                      class="d-flex justify-content-between"
                      style="
                        border-bottom: 1px solid #dee2e6;
                        padding: 6px 16px;
                      "
                    >
                      <div class="d-flex flex-column">
                        <span style="font-weight: 800">{{ item.name }}</span>
                        <span style="font-size: 12px" v-if="item.selectedUsers"
                          >{{ item.selectedUsers.length }} customers from
                          CSV</span
                        >
                      </div>
                      <b-button
                        size="sm"
                        variant="outline-danger"
                        @click="deleteSegmentItem(item)"
                        style="height: 29px !important"
                      >
                        Remove
                      </b-button>
                    </div>
                  </div>
                </div>
              </draggable>
            </b-col>
          </b-row>
        </b-card>
      </b-col>

      <b-col cols="12">
        <b-card>
          <h5 class="font-weight-bold mb-0">Marketing Assets</h5>
          <div class="mt-1">
            <b-tabs pills>
              <b-tab active>
                <template #title>
                  <span class="d-flex align-items-center" style="gap: 6px">
                    Banner
                    <feather-icon
                      :icon="
                        isBannerComplete ? 'CheckCircleIcon' : 'XCircleIcon'
                      "
                      size="16"
                      :class="isBannerComplete ? 'text-success' : 'text-danger'"
                    />
                  </span>
                </template>
                <b-row>
                  <b-col
                    md="3"
                    sm="6"
                    v-for="banner in banners"
                    :key="banner.key"
                  >
                    <b-form-group>
                      <p class="font-weight-bold mb-0">{{ banner.label }}</p>

                      <!-- File input -->
                      <b-form-file
                        v-model="banner.file"
                        accept="image/*"
                        @input="onFileChange(banner)"
                        placeholder="Choose File"
                        browse-text="Choose File"
                      ></b-form-file>

                      <small class="text-muted d-block mt-1">{{
                        banner.desc
                      }}</small>

                      <!-- Preview + Loading -->
                      <b-skeleton
                        v-if="banner.loading"
                        class="skeleton-box mx-auto rounded border"
                        style="width: 100%; min-height: 150px"
                      ></b-skeleton>

                      <img
                        v-else-if="
                          banner.previewUrl &&
                          formBanner.bannerPosition === banner.key
                        "
                        :src="banner.previewUrl"
                        alt="preview"
                        class="img-fluid rounded border"
                        style="
                          width: 100%;
                          min-width: 100%;
                          min-height: 150px;
                          height: 150px;
                          object-fit: cover;
                        "
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <validation-provider
                      #default="{ errors }"
                      name="banner link"
                      :rules="
                        formBanner.bannerPosition ? 'required' : undefined
                      "
                    >
                      <b-form-group
                        label="Banner Link URL"
                        label-class="font-weight-bold"
                      >
                        <b-form-input
                          v-model="formBanner.bannerLink"
                          placeholder="https://example.com/promotion"
                        ></b-form-input>
                        <div>
                          <small class="text-danger">{{ errors[0] }}</small>
                        </div>
                        <small class="text-muted"
                          >Where should users go when they click the
                          banner?</small
                        >
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="12">
                    <b-row>
                      <b-col cols="3">
                        <validation-provider
                          #default="{ errors }"
                          name="start date"
                          :rules="
                            formBanner.bannerPosition ? 'required' : undefined
                          "
                        >
                          <b-form-group label="Start Date">
                            <flat-pickr
                              :value="formBanner.startDate"
                              class="form-control"
                              :config="configDateBanner"
                              placeholder="dd/mm/yyyy"
                              @input="(val) => (formBanner.startDate = val)"
                            />
                            <small class="text-danger">{{ errors[0] }}</small>
                          </b-form-group>
                        </validation-provider>
                      </b-col>
                      <b-col cols="3">
                        <validation-provider
                          #default="{ errors }"
                          name="end date"
                          :rules="
                            formBanner.bannerPosition ? 'required' : undefined
                          "
                        >
                          <b-form-group label="End Date">
                            <flat-pickr
                              :value="formBanner.endDate"
                              class="form-control"
                              :config="configDateBanner"
                              placeholder="dd/mm/yyyy"
                              @input="(val) => (formBanner.endDate = val)"
                            />
                            <small class="text-danger">{{ errors[0] }}</small>
                          </b-form-group>
                        </validation-provider>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>

                <b-row class="mt-1"
                  ><b-col>
                    <div
                      class="d-flex align-items-center justify-content-between"
                    >
                      <h6 class="font-weight-bold mb-0">Desktop Preview</h6>
                    </div>
                    <div class="mt-2">
                      <DesktopUI
                        :banners="banners"
                        :bannerPosition="formBanner.bannerPosition"
                      />
                    </div> </b-col
                ></b-row>

                <b-row class="mt-1">
                  <b-col cols="12">
                    <div
                      class="d-flex align-items-center justify-content-between"
                    >
                      <h6 class="font-weight-bold mb-0">Mobile Preview</h6>
                    </div>
                    <div class="mt-1">
                      <MobileUI :bannerCarousel="banners[0]" />
                    </div>
                  </b-col>
                </b-row>
              </b-tab>

              <!-- INAPP TAB -->
              <b-tab title="INAPP">
                <p class="text-muted">INAPP configuration here</p>
              </b-tab>

              <!-- EMAIL TAB -->
              <b-tab title="Email">
                <p class="text-muted">Email template configuration</p>
              </b-tab>

              <!-- SMS TAB -->
              <b-tab title="SMS">
                <p class="text-muted">SMS content configuration</p>
              </b-tab>
            </b-tabs>
          </div>
        </b-card>
      </b-col>
      <b-col cols="12">
        <b-card>
          <h5 class="font-weight-bold mb-0">Terms & Conditions (Mandatory)</h5>
          <div class="mt-1">
            <b-form-group label="Choose Template">
              <b-form-select
                v-model="form.templateId"
                :options="templates"
              ></b-form-select>
            </b-form-group>
            <b-form-group label="Terms Content">
              <b-form-textarea
                v-model="form.termFinalContent"
                rows="4"
              ></b-form-textarea>
              <small>You can edit the template text before publishing</small>
            </b-form-group>
          </div>
        </b-card>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="12" class="text-right">
        <b-button
          @click="$router.push('/promotions/price-promotions')"
          variant="outline-secondary"
          class="mr-1"
        >
          Cancel
        </b-button>
        <b-button
          @click="
            handleCreatePromotion({ status: 'inactive', action: 'draft' })
          "
          variant="outline-secondary"
          class="mr-1"
          :disabled="loadingAction === 'draft' && loadingCreatePromotion"
          style="min-width: 136px"
        >
          Save as Draft
        </b-button>

        <b-button
          :disabled="loadingAction === 'publish' && loadingCreatePromotion"
          @click="
            handleCreatePromotion({ status: 'active', action: 'publish' })
          "
          variant="primary"
          style="min-width: 172px"
          class="mr-1"
        >
          Publish Promotion
        </b-button>
        <b-button
          :disabled="loadingAction === 'now' && loadingCreatePromotion"
          @click="
            handleCreatePromotion({
              status: 'active',
              isNow: true,
              action: 'now',
            })
          "
          variant="primary"
          style="min-width: 172px"
        >
          Publish Promotion Now
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Spinner from "@core/components/Spinner";
import {
  BButton,
  BCard,
  BCol,
  BPagination,
  BRow,
  BButtonGroup,
  BTable,
  BCardBody,
  BFormInput,
  BMedia,
  BAvatar,
  BProgress,
  BProgressBar,
  BFormTextarea,
  BFormCheckbox,
  BFormRadioGroup,
  BFormRadio,
  BFormGroup,
  BImg,
  BFormCheckboxGroup,
  BFormSelect,
  BInputGroup,
  BFormFile,
  BTab,
  BTabs,
  BBadge,
  BInputGroupAppend,
  BInputGroupPrepend,
  BSkeleton,
} from "bootstrap-vue";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import DualListbox from "../../components/DuoListBox.vue";
import { formatDateSend, getOrdinalSuffix } from "@/helpers/utils";
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/default.css";
import draggable from "vuedraggable";
import { mapState, mapActions } from "vuex";
import { endOfDay, format, startOfDay } from "date-fns";
import useToastHandler from "@/services/toastHandler";
import { parse } from "csv-parse";
import { v4 as uuidv4 } from "uuid";
import { Vue2TinymceEditor } from "vue2-tinymce-editor";
import MobileUI from "../../../marketing/BannerManagement/components/MobileUI.vue";
import DesktopUI from "../../../marketing/BannerManagement/components/DesktopUI.vue";
import { sanitizePayload } from "@/helpers/utils";
export default {
  components: {
    BButton,
    BCard,
    BRow,
    BCol,
    BTable,
    BMedia,
    BPagination,
    vSelect,
    Spinner,
    BButtonGroup,
    BTable,
    BCardBody,
    BFormInput,
    BAvatar,
    flatPickr,
    BProgress,
    BProgressBar,
    ValidationProvider,
    ValidationObserver,
    BFormTextarea,
    BFormCheckbox,
    BFormRadioGroup,
    BFormRadio,
    BFormGroup,
    BImg,
    BFormCheckboxGroup,
    BFormSelect,
    BInputGroup,
    BFormFile,
    DualListbox,
    VueSlider,
    BTab,
    BTabs,
    BBadge,
    draggable,
    BInputGroupAppend,
    Vue2TinymceEditor,
    BInputGroupPrepend,
    BSkeleton,
    MobileUI,
    DesktopUI,
  },
  data() {
    const customerLimitOptions = [
      { value: null, text: "Unlimited" },
      { value: 100, text: "First 100 Customers" },
      { value: 500, text: "First 500 Customers" },
      { value: 1000, text: "First 1000 Customers" },
      { value: null, text: "Custom Limit" },
    ];
    const marketTypeOptions = [
      { value: "win", text: "WIN" },
      { value: "place", text: "PLACE" },
    ];

    const racingCodes = [
      { value: null, text: "-- All Racing Codes --" },
      { value: "R", text: "Racing" },
      { value: "G", text: "Greyhounds" },
      { value: "H", text: "Harness" },
    ];
    const marketTypesRacing = [
      { value: "win", text: "WIN" },
      { value: "place", text: "PLACE" },
    ];
    const marketTypesSport = [
      { value: null, text: "-- Select Market Type --" },
      { value: "h2h", text: "Head to Head" },
      { value: "win", text: "Team to Win" },
      { value: "line", text: "Line" },
      { value: "points", text: "Total Points" },
    ];
    const tabs = [
      {
        id: 0,
        name: "Racing",
        value: "Single Racing",
      },
      {
        id: 1,
        name: "Sport",
        value: "Single Sport",
      },
    ];

    const banners = [
      {
        key: "carousel",
        label: "Carousel Banner (Web & Mobile)",
        desc: "Inside website carousel - 1200x400px",
        width: 1200,
        height: 400,
        resourceId: null,
        previewUrl: null,
        loading: false,
      },
      {
        key: "top",
        label: "Top Banner",
        desc: "Full-width top banner - 1920x150px",
        width: 1920,
        height: 150,
        resourceId: null,
        previewUrl: null,
        loading: false,
      },
      {
        key: "left",
        label: "Left Sidebar Banner",
        desc: "Left side promotional banner - 220x600px",
        width: 220,
        height: 600,
        resourceId: null,
        previewUrl: null,
        loading: false,
      },
      {
        key: "right",
        label: "Right Sidebar Banner",
        desc: "Right side promotional banner - 300x600px",
        width: 300,
        height: 600,
        resourceId: null,
        previewUrl: null,
        loading: false,
      },
    ];
    const deviceOptions = [
      { value: "desktop", text: "Desktop" },
      { value: "mobile-web", text: "Mobile Web" },
      { value: "mobile-app", text: "Mobile App" },
      { value: "tablet", text: "Tablet" },
    ];
    return {
      form: {
        name: "",
        type: "Price",
        description: "",
        additionalInfo: "",
        discountValue: 0,
        maxDiscount: 0,
        minDiscount: 0,
        globalLimit: 0,
        globalExposureLimit: 0,
        discountType: "price",
        active: true,
        cannotBeBoosted: false,
        activeStatus: "inactive",
        startTime: new Date(),
        endTime: null,
        subType: null,
        resources: [],
        templateId: null,
        termFinalContent: "",
      },
      customerLimitOptions,
      marketTypeOptions,
      configDate: {
        enableTime: true,
        altInput: true,
        altFormat: "d/m/Y H:i (AEDT)",
        dateFormat: "Y-m-d H:i:S",
        static: true,
      },
      editorOptions: {
        forced_root_block: "div",
        height: 200,
        content_style: `
        html, body {
          background-color: #0766AA !important; 
          height: 100%;                         
          margin: 0;                        
          padding: 10px;               
          font-family: Arial, sans-serif;
          box-sizing: border-box;
        }
        
      `,
        forced_root_block_attrs: {
          style: "color: white;",
        },
      },
      configDateMeeting: {
        enableTime: false,
        dateFormat: "Y-m-d",
        static: true,
      },
      optionsType: [
        { label: "Bonus Bet", value: "mbs-cash" },
        { label: "Cash Refund", value: "mbs-bonus" },
        { label: "Price", value: "price" },
      ],

      selectedRacingCodes: [],
      meetings: [],
      races: [],
      rules: [],
      selectedMeetings: null,
      selectedRules: [],

      profiles: [],
      selectedProfile: [],
      activeTabCustomer: "Customer Profiles",
      selectedSegment: [],
      selectedRaceDate: new Date(),
      selectAllMeetings: false,
      selectAllRaces: false,
      loadingAllMeetings: false,
      editData: null,

      marketTypesSport,
      marketTypesRacing,
      customerLimitOptions,
      search: "",
      showDropdown: false,
      filter: {
        racingCode: racingCodes[0].value,
      },
      racingCodes,
      selectedMeeting: [],
      meetingActive: null,
      selectedRace: null,
      raceInMeeting: [],
      runners: [],
      selectedRunner: null,
      regions: [
        { label: "Metro", value: "Metro", type: "venueType" },
        { label: "Country", value: "Country", type: "venueType" },
        { label: "Provincial", value: "Provincial", type: "venueType" },
      ],
      activeTab: tabs[0].id,
      tabs,
      trackList: [],
      sports: [],
      items: [],
      targets: [],
      selectedDate: null,
      selectedSport: {
        sport: null,
        league: null,
        event: null,
        market: null,
      },
      leagues: [],
      events: [],
      markets: [],
      selections: [],
      templates: [],
      banners,
      formBanner: {
        bannerId: null,
        bannerLink: "",
        bannerPosition: "",
        startDate: "",
        endDate: "",
      },
      configDateBanner: {
        enableTime: true,
        noCalendar: false,
        time_24hr: true,
        altFormat: "d-m-Y H:i",
      },
      loadingAction: null,
      // User Picker
      userPickerSearch: "",
      userPickerUsers: [],
      userPickerLoading: false,
      userPickerPage: 1,
      userPickerHasMore: true,
      userPickerVerifyingId: null,
      confirmedUsers: [],
    };
  },
  watch: {
    userPickerSearch: {
      handler() {
        clearTimeout(this._userPickerSearchTimer);
        this._userPickerSearchTimer = setTimeout(() => {
          this.handleUserPickerSearch();
        }, 300);
      },
    },
    selectedRacingCodes(val) {
      this.fetchListMeetings();
    },
    selectedMeetings(val) {
      if (this.selectAllRaces) this.selectAllRaces = false;
    },
    selectedRaceDate(val) {
      this.fetchListMeetings();
    },
    async "filter.racingCode"() {
      if (!this.selectedDate) return;
      await this.fetchMeetings();
      this.updateSelectedMeeting();
    },
    async selectedDate() {
      await this.fetchMeetings();
      this.updateSelectedMeeting();
    },
    selectedRace(val) {
      this.getRunnersInRace(val);
      this.selectedRunner = null;
    },
    selectedIssuanceType(val) {
      this.handleSelectedIssuanceType(val);
    },
    activeTab(val) {
      const currentTab = this.tabs.find((t) => t.id === val);
      switch (currentTab.name) {
        case "Racing":
          this.form.subType = currentTab.value;
          break;
        case "Sport":
          this.form.subType = currentTab.value;
          break;
      }
    },
    "selectedSport.sport"(val) {
      this.fetchLeagueOfSport(val);
    },
    "selectedSport.league"(val) {
      this.fetchEventsOfLeague(val);
    },
    "selectedSport.event": {
      handler(val) {
        this.fetchMarketsOfEvent(val);
      },
      immediate: true,
    },
    "selectedSport.market"(val) {
      this.selections = val.selections.map((i) => {
        return {
          ...i,
          text: `${i.selectionName} - ${i.marketSelectionId}`,
          value: i.marketSelectionId,
        };
      });
    },
    termConditions(val) {
      if (!val) return;
      this.templates = val.map((i) => {
        return {
          ...i,
          value: i.id,
          text: i.name,
        };
      });
    },
    "form.templateId"(val) {
      const selectedTemplate = this.termConditions.find((i) => i.id === val);
      this.form.termFinalContent = selectedTemplate
        ? selectedTemplate.content
        : "";
    },
  },
  computed: {
    ...mapState("promotions/list", ["loadingCreatePromotion"]),
    ...mapState("promotions/price-promotions", ["termConditions"]),
    isBannerComplete() {
      return !!(
        this.formBanner.bannerPosition &&
        this.formBanner.bannerLink &&
        this.formBanner.startDate &&
        this.formBanner.endDate
      );
    },
    filteredMeeting() {
      const s = this.search.toLowerCase();
      if (!s) return [];
      return this.trackList.filter((r) => r.label.toLowerCase().includes(s));
    },
  },
  async created() {
    await Promise.all([
      this.fetchSegmentList(),
      this.fetchProfileList(),
      this.fetchSports(),
      this.fetchMeetings(),
      this.getTermConditions(),
    ]);
    await this.fetchDetailPromotion();
    this.loadUserPickerPage();
  },
  methods: {
    ...mapActions({
      getSegmentsList: "segment/list/getSegmentsList",
      getProfileList: "user/list/getProfileList",
      getListMeetings: "trading/racing/getListMeetings",
      getRacesOfMeeting: "trading/racing/getRacesOfMeeting",
      getDetailPromotion: "promotions/list/getDetailPromotion",
      deletePromotionTarget: "promotions/list/deletePromotionTarget",
      updatePromotionTargets: "promotions/list/updatePromotionTargets",
      updatePromotion: "promotions/list/updatePromotion",
      createUserList: "user/list/createUserList",
      getUserList: "user/list/getUserListByGroup",
      getListSport: "sport/list/getListSport",
      getRaces: "promotions/price-promotions/getRaceInMeeting",
      getRunners: "promotions/price-promotions/getRunnerInRace",
      getListLeagueOfSport: "sport/list/getListLeagueOfSport",
      getListEventOfLeague: "sport/list/getListEventOfLeague",
      getListMarketOfEvent: "sport/list/getListMarketOfEvent",
      getListSelectionOfMarket: "sport/list/getListSelectionOfMarket",
      getTermConditions: "promotions/price-promotions/getTermConditions",
      getAllUserList: "user/list/getUserList",
      uploadBannerImage: "marketing/banner/uploadBannerImage",
    }),
    // User Picker methods
    handleUserPickerSearch() {
      this.userPickerUsers = [];
      this.userPickerPage = 1;
      this.userPickerHasMore = true;
      this.loadUserPickerPage();
    },
    async loadUserPickerPage() {
      if (this.userPickerLoading || !this.userPickerHasMore) return;
      this.userPickerLoading = true;
      try {
        const limit = 20;
        const data = await this.getAllUserList({
          search: this.userPickerSearch || "",
          limit,
          page: this.userPickerPage,
        });
        if (!data || data.length === 0) {
          this.userPickerHasMore = false;
        } else {
          this.userPickerUsers = [...this.userPickerUsers, ...data];
          this.userPickerPage += 1;
          if (data.length < limit) this.userPickerHasMore = false;
        }
      } catch (e) {
        this.userPickerHasMore = false;
      } finally {
        this.userPickerLoading = false;
      }
    },
    handleUserListScroll(e) {
      const el = e.target;
      const nearBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 60;
      if (nearBottom && this.userPickerHasMore && !this.userPickerLoading) {
        this.loadUserPickerPage();
      }
    },
    isUserConfirmed(userId) {
      return this.confirmedUsers.some((u) => u.userId === userId);
    },
    async handleSelectUser(user) {
      if (this.userPickerVerifyingId) return;
      if (this.isUserConfirmed(user.userId)) {
        this.confirmedUsers = this.confirmedUsers.filter(
          (u) => u.userId !== user.userId
        );
        return;
      }
      this.userPickerVerifyingId = user.userId;
      try {
        this.confirmedUsers = [...this.confirmedUsers, user];
        this.showToastSuccess(
          "success",
          `User "${user.username || user.userId}" added.`
        );
      } catch (e) {
        this.showToastError(false, "Failed to add user.");
      } finally {
        this.userPickerVerifyingId = null;
      }
    },
    removeConfirmedUser(idx) {
      this.confirmedUsers.splice(idx, 1);
    },
    handleAddConfirmedUsersToSegment() {
      if (!this.confirmedUsers.length) return;
      const newSegment = {
        name: "Untitled",
        uuid: uuidv4(),
        selectedUsers: this.confirmedUsers.map((u) => u.userId),
        targetType: "UserList",
        source: "customer",
      };
      this.selectedSegment = [...this.selectedSegment, newSegment];
      this.confirmedUsers = [];
      this.showToastSuccess(
        "success",
        `${newSegment.selectedUsers.length} users added to recurrence list.`
      );
    },
    getOrdinalSuffix,
    showModalMarketing() {
      this.$refs.marketing.show();
    },
    formatter(value) {
      return `${value}`;
    },
    convertMeetingType(type) {
      switch (type) {
        case "R":
          return "Thoroughbred";
        case "G":
          return "Greyhound";
        case "H":
          return "Harness";
        default:
          return "";
      }
    },
    getBadgeVariant(type) {
      switch (type) {
        case "Thoroughbred":
          return "success";
        case "Greyhound":
          return "info";
        case "Harness":
          return "warning";
        default:
          return "secondary";
      }
    },
    toggleMeetingSelection(item) {
      this.selectedMeetings = item;
      this.fetchListRacesOfMeeting();
    },
    handleSelectProfile(item) {
      if (this.selectedProfile.some((i) => i === item))
        return (this.selectedProfile = this.selectedProfile.filter(
          (i) => i !== item
        ));
      this.selectedProfile = [...this.selectedProfile, item];
    },
    handleDrag(event) {},
    handleDrop(event) {
      const draggedTag = event.clone?.innerText?.trim();
      if (
        !draggedTag ||
        this.selectedSegment.some((i) => i.name === draggedTag)
      )
        return;
      const item = this.customerSegments.find((i) => i.name === draggedTag);
      this.selectedSegment.splice(event.newIndex, 0, {
        ...item,
      });
    },
    async fetchSegmentList() {
      const { data } = await this.getSegmentsList({
        limit: 100,
      });
      this.customerSegments = data.map((i) => {
        return {
          name: i.name.trim(),
          id: i.id,
        };
      });
    },
    async fetchProfileList() {
      const data = await this.getProfileList();
      this.profiles = data.map((i) => i.profileTypeId);
    },
    mapPromotionForm(data) {
      this.form = {
        name: data.name,
        code: data.code,
        type: data.type,
        description: data.description,
        additionalInfo: data.additionalInfo,
        subType: data.subType,
        discountValue: data.discountValue,
        maxDiscount: data.maxDiscount,
        minDiscount: data.minDiscount,
        globalLimit: data.globalLimit,
        globalExposureLimit: data.globalExposureLimit,
        discountType: data.discountType,
        active: data.active,
        startTime: data.startTime,
        endTime: data.endTime,
        currentResource: data.banner ? data.banner?.resources?.[0] : null,
        templateId: data.templateId || null,
        termFinalContent: data.termFinalContent || "",
      };
    },
    mapBannerForm(data) {
      if (!data) return;
      this.formBanner = {
        ...this.formBanner,
        bannerId: data.bannerId,
        startDate: data.startDate,
        endDate: data.endDate,
        bannerLink: data.bannerLink,
        bannerPosition: data.bannerPosition,
        platform: data.platform,
      };
    },
    mapBannerResource(data) {
      if (!data?.resources?.length) return;
      const index = this.banners.findIndex(
        (b) => b.key === data.bannerPosition
      );
      if (index === -1) return;
      const resource = data.resources[0];
      this.banners[index] = {
        ...this.banners[index],
        resourceId: resource?.resourceId || null,
        previewUrl: resource?.url || null,
      };
      this.form.currentResource = this.banners[index];
    },
    mapBannerTargets(bannerTargets = []) {
      if (!bannerTargets.length) return;
      const isAllToView = bannerTargets.some(
        (t) => t.targetId === "all-user-verified"
      );
      if (isAllToView) this.form.allToView = true;
      this.selectedProfile = [];
      this.tempProfiles = [];
      this.selectedSegment = [];
      this.tempCustomerSegments = [];

      const profileSet = new Set();
      const segmentSet = new Set();
      const segmentMap = Object.fromEntries(
        this.customerSegments.map((s) => [s.id, s])
      );

      bannerTargets.forEach((t) => {
        if (t.targetType === "Profile" && !profileSet.has(t.targetId)) {
          profileSet.add(t.targetId);
          this.selectedProfile.push(t.targetId);
          this.tempProfiles.push(t);
        }

        if (t.targetType === "CustomerSegment") {
          const seg = segmentMap[t.targetId];
          if (seg && !segmentSet.has(seg.id)) {
            segmentSet.add(seg.id);
            this.selectedSegment.push(seg);
            this.tempCustomerSegments.push(t);
          }
        }
      });
    },
    async fetchDetailPromotion() {
      if (!this.$router.currentRoute.params.id) return;
      const { data: data } = await this.getDetailPromotion(
        this.$router.currentRoute.params.id
      );
      this.mapPromotionForm(data);
      this.$nextTick(() => {
        this.form.termFinalContent = data.termFinalContent || "";
      });
      this.mapBannerForm(data.banner);
      this.mapBannerResource(data.banner);

      this.activeTab = this.tabs.find((t) => t.value === data.subType).id;
      this.rules = data.rules.map((i) => ({
        conditionType: i.conditionType,
        conditionValue: i.conditionValue,
      }));
      const targets = data.targets.filter((i) => i.targetType !== "Profile");
      const selectedSegment = [];
      for (const i of targets) {
        if (i.targetType === "CustomerSegment") {
          const item = this.customerSegments.find((r) => r.id === i.targetId);
          if (item) selectedSegment.push(item);
          continue;
        }

        let list;
        if (i.targetType === "UserList") {
          list = await this.fetchUserList(i.targetId);
        }

        selectedSegment.push({
          id: i.targetId,
          ...i,
          name: "Untitled",
          selectedUsers: list,
        });
      }
      this.selectedSegment = selectedSegment;

      this.selectedProfile = data.targets
        .filter((i) => i.targetType === "Profile")
        .map((i) => {
          const item = this.profiles.find((r) => r === i.targetId);
          return item;
        });

      this.editData = data;
      if (data.subType === "Single Racing") {
        this.getDataOfListRuleTypeLegId();
      } else {
        this.selectedRules = data.rules.map((i) => {
          return {
            conditionType: i.conditionType,
            conditionValue: i.conditionValue,
          };
        });
      }
    },
    async fetchUserList(id) {
      const res = await this.getUserList(id);
      return res.data.map((i) => i.userId);
    },
    async getDataOfListRuleTypeLegId() {
      const list = this.editData.rules.filter(
        (i) => i.conditionType === "legId"
      );
      const marketType = this.editData.rules.find(
        (i) => i.conditionType === "selectionType"
      );
      if (marketType) {
        this.form.marketType = marketType.conditionValue;
      }
      const racePromises = list.map((race) => {
        return this.getRacesOfMeeting({
          limit: 1,
          raceId: race.conditionValue,
        }).then((res) => {
          return {
            ...res[0],
          };
        });
      });

      const racesPerMeeting = await Promise.all(racePromises);
      this.selectedRules = racesPerMeeting.map((i) => {
        return {
          ...i,
          conditionValue: i.raceId,
          conditionType: "legId",
        };
      });
    },
    deleteSegmentItem(item) {
      this.selectedSegment = this.selectedSegment.filter(
        (i) => i.id !== item.id
      );
    },
    async handleCreatePromotion({ status, isNow = false, action }) {
      const { currentResource, activeStatus, ...restFormPromotion } = this.form;
      this.loadingAction = action;
      this.form.activeStatus = status;
      const formatSelectedPosition = this.selectedProfile.map((i) => {
        return {
          targetType: "Profile",
          targetId: i,
        };
      });

      const formatSelectedSegment = [];
      for (const i of this.selectedSegment) {
        if (!i.selectedUsers) {
          formatSelectedSegment.push({
            targetType: "CustomerSegment",
            targetId: i.id,
          });
          continue;
        }

        let targetUserListId;
        if (i && i.targetType === "UserList" && !i.targetId) {
          const resListId = await this.createUserList({
            userIds: i.selectedUsers,
          });
          if (resListId && resListId.data) targetUserListId = resListId.data;
        } else if (i.targetType === "UserList" && i.targetId) {
          targetUserListId = i.targetId;
        }

        formatSelectedSegment.push({
          targetType: "UserList",
          targetId: targetUserListId,
        });
      }
      const { startDate, endDate, ...restFormBanner } = this.formBanner;
      const bannerInfo = {
        ...restFormBanner,
      };
      if (startDate && endDate) {
        bannerInfo.startDate = this.formatDateSend(startDate);
        bannerInfo.endDate = this.formatDateSend(endDate);
        bannerInfo.platform = "all";
      }

      const emptyBanner = !currentResource;
      if (emptyBanner) {
        bannerInfo.resourceIds = this.banners
          .filter((b) => b.resourceId)
          .map((b) => b.resourceId);
      } else {
        const newResource = this.banners.find(
          (banner) =>
            bannerInfo.bannerPosition === banner.key && banner.resourceId
        );
        if (currentResource) {
          if (currentResource.resourceId !== newResource.resourceId) {
            bannerInfo.resources = [
              {
                oldResourceId: currentResource.resourceId,
                resourceId: newResource.resourceId,
              },
            ];
          }
        } else {
          bannerInfo.resourceIds = [newResource.resourceId];
        }
      }
      const payload = sanitizePayload({
        ...restFormPromotion,
        startTime: this.formatDateSend(
          isNow ? new Date() : restFormPromotion.startTime
        ),
        endTime: this.formatDateSend(restFormPromotion.endTime),
        status,
        rules: this.rules,
        ...(!!bannerInfo.bannerPosition && { bannerInfo }),
        templateId: this.form.templateId,
        termFinalContent: this.form.termFinalContent,
      });
      if (this.$router.currentRoute.params.id) {
        const [resPromo] = await Promise.all([
          this.handleUpdatePromotion(payload),
          this.handleUpdatePromotionTargets([
            ...formatSelectedPosition,
            ...formatSelectedSegment,
          ]),
        ]);
        if (resPromo)
          this.showToastSuccess(
            "success",
            "This promotion updated successfully!"
          );
        this.fetchDetailPromotion();
      }
    },
    async handleUpdatePromotion(data) {
      const res = await this.updatePromotion({
        promotionId: this.$router.currentRoute.params.id,
        ...data,
      });
      return res;
    },
    convertListToIdsTarget(l) {
      return l.reduce((acc, item, index) => {
        const key = `ids[${index}]`;
        acc[key] = item.targetId;
        return acc;
      }, {});
    },
    async handleUpdatePromotionTargets(newTargets) {
      const promotionId = this.$router.currentRoute.params.id;
      const oldTargets = this.editData.targets.map((t) => ({
        targetType: t.targetType,
        targetId: t.id,
      }));
      const isSame = (a, b) =>
        a.targetType === b.targetType && a.targetId === b.targetId;

      const targetsToDelete = oldTargets.filter(
        (oldT) => !newTargets.some((newT) => isSame(oldT, newT))
      );
      const targetsToAdd = newTargets.filter(
        (newT) => !oldTargets.some((oldT) => isSame(oldT, newT))
      );
      if (targetsToDelete.length) {
        await this.deletePromotionTarget(
          this.convertListToIdsTarget(targetsToDelete)
        );
      }
      if (targetsToAdd.length) {
        await this.updatePromotionTargets({
          promotionId,
          targets: targetsToAdd,
        });
      }
    },
    convertListToIdsObject(l) {
      return l.reduce((acc, item, index) => {
        const key = `meetingTypes[${index}]`;

        acc[key] = item;

        return acc;
      }, {});
    },
    async fetchListMeetings() {
      const res = await this.getListMeetings({
        limit: 100,
        meetingDateFrom: startOfDay(
          new Date(this.selectedRaceDate)
        ).toISOString(),
        meetingDateTo: endOfDay(new Date(this.selectedRaceDate)).toISOString(),
        ...(!!this.selectedRacingCodes.length &&
          this.convertListToIdsObject(this.selectedRacingCodes)),
      });
      this.meetings = res;
    },
    async fetchListRacesOfMeeting() {
      if (!this.selectedMeetings) return;
      const res = await this.getRacesOfMeeting({
        limit: 100,
        meetingId: this.selectedMeetings.meetingId,
      });
      this.races = res.map((i) => {
        return {
          ...i,
          venueName: this.selectedMeetings.venueName,
          meetingId: this.selectedMeetings.meetingId,
        };
      });
    },
    handleRemoveRaceItem(item) {
      this.selectedRules = this.selectedRules.filter(
        (i) => i.conditionValue !== item.conditionValue
      );
    },
    onClickInput() {
      const fileInput = this.$refs.fileInput;
      fileInput.click();
    },
    _resetInputFile() {
      this.$refs.fileInput.value = null;
    },
    handleFileUpload(event) {
      const file = event.target.files[0];
      const reader = new FileReader();
      reader.onload = () => {
        this.parseCSV(reader.result);
      };
      reader.readAsText(file);
      this._resetInputFile();
    },
    parseCSV(csvData) {
      parse(csvData, { delimiter: "," }, (err, data) => {
        if (err) {
          console.error(err);
          return;
        }
        data.shift();
        const newList = data.map((i) => i[0]);

        if (newList.length > 0) {
          this.selectedSegment = [
            ...this.selectedSegment,
            {
              name: "Untitled",
              id: uuidv4(),
              targetType: "UserList",
              selectedUsers: newList,
            },
          ];
          this.activeTabCustomer = "Customer Segments";
        }
      });
    },
    handleSearch() {
      this.showDropdown = !!this.search;
    },
    selectMeeting(meeting) {
      if (this.selectedMeeting.length) {
        this.showDropdown = false;
        return;
      }
      this.selectedMeeting = [meeting];
      this.meetingActive = meeting;
      this.showDropdown = false;
    },
    async fetchSports() {
      const data = await this.getListSport({
        limit: 100,
        status: "active",
      });
      if (!data && data.data.length <= 0)
        return this.showToastError(false, "Error fetching sports list");
      this.sports = data.data.map((sport) => {
        return {
          code: sport.code,
          text: sport.name,
          value: sport.id,
          type: "sportId",
        };
      });
    },
    async fetchMeetings() {
      const { selectedDate, filter } = this;
      const payload = {
        limit: 100,
        source: "RAS",
        status: "active",
        ...(selectedDate && {
          meetingDateFrom: `${selectedDate}T00:00:00Z`,
          meetingDateTo: `${selectedDate}T23:00:00.000Z`,
        }),
        ...(filter.racingCode && {
          meetingTypes: filter.racingCode,
        }),
      };
      const data = await this.getListMeetings(payload);
      if (!data && data.length <= 0)
        return this.showToastError(false, "Error fetching meetings list");
      this.trackList = data.map((meeting) => {
        return {
          ...meeting,
          label: meeting.venueName,
          value: meeting.venueName,
          type: "venueName",
        };
      });
    },

    variantTypeRacing(type) {
      switch (type) {
        case "R":
          return "primary";
        case "H":
          return "success";
        case "G":
          return "warning";
        default:
          return "secondary";
      }
    },
    updateSelectedMeeting() {
      if (!this.selectedDate) return (this.selectedMeeting = []);
      this.selectedMeeting = this.trackList;
      this.meetingActive = null;
      this.raceInMeeting = [];
      this.selectedRace = null;
      this.runners = [];
      this.selectedRunner = null;
    },
    async getRacesInMeeting(meeting) {
      const res = await this.getRaces(meeting.meetingId);
      this.raceInMeeting = res.map((i) => {
        return {
          text: `Race ${i.eventNo} - ${i.eventName} - ${format(
            new Date(i.utcTime),
            "HH:mm a"
          )}`,
          value: i.raceId,
        };
      });
      this.meetingActive = meeting;
      this.selectedRace = null;
      this.runners = [];
      this.selectedRunner = null;
    },
    async getRunnersInRace(race) {
      const res = await this.getRunners(race.value);
      this.runners = res.map((i) => {
        const { runnerName, runnerId, runnerNo, result } = i;
        return {
          runnerName,
          runnerNo,
          result,
          runnerId,
        };
      });
      this.selectedRunner = null;
    },

    async fetchLeagueOfSport(sportId) {
      const res = await this.getListLeagueOfSport({
        sportId,
        limit: 100,
      });
      this.leagues = res.data.map((i) => {
        return {
          ...i,
          text: i.name,
          value: i.id,
        };
      });
    },
    async fetchEventsOfLeague(leagueId) {
      const res = await this.getListEventOfLeague({
        sportLeagueId: leagueId,
      });
      this.events = res.data.map((i) => {
        return {
          ...i,
          text: i.eventTitle,
          value: i.eventId,
        };
      });
    },
    async fetchMarketsOfEvent(eventId) {
      const res = await this.getListMarketOfEvent({
        eventId,
      });
      this.markets = res.data.map((i) => {
        return {
          ...i,
          text: i.marketType,
          value: i.marketId,
        };
      });
    },
    async onFileChange(banner) {
      if (!banner.file) return;
      try {
        this.formBanner.bannerPosition = banner.key;
        banner.loading = true;
        const result = await this.uploadBannerImage(banner);
        banner.previewUrl = result[0].url;
        banner.resourceId = result[0].resourceId;
        banner.loading = false;
      } catch (error) {
        banner.loading = false;
      }
    },
  },
  setup() {
    const { showToastSuccess, showToastError } = useToastHandler();

    return {
      showToastSuccess,
      showToastError,

      format,
      formatDateSend,
    };
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
@import "@core/scss/vue/libs/vue-select.scss";

p {
  margin-bottom: 0;
}
.circle-cancel {
  position: absolute;
  top: -4px;
  right: -7px;
  border: 1px solid black;
  background: white;
  border-radius: 50%;
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.box {
  padding: 6px 10px;
  border: 1px solid #6c757d;
  border-left: none;
  cursor: pointer;
  &-active {
    background-color: #6c757d;
    color: white;
  }
  &:first-child {
    border-left: 1px solid #6c757d;
    border-radius: 4px 0 0 4px;
  }
  &:last-child {
    border-radius: 0 4px 4px 0;
  }
}
</style>

<style lang="scss" scoped>
.meeting-list-container,
.race-list-container {
  border-radius: 0.25rem;
}

.meeting-item {
  border-bottom: 1px solid #eee;
  transition: background-color 0.2s;
  background-color: white;
}

.meeting-item:last-child {
  border-bottom: none;
}

.meeting-item:hover {
  background-color: #e0e1e2;
}

.meeting-item-selected {
  background-color: #0d6efd;
  color: white;
}

.grid-3 {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
}
.active-tab {
  color: #0d6efd;
  border: 1px solid #dee2e6;
  border-radius: 5px 5px 0 0;
  border-bottom: 1px solid #0d6efd;
}

.active-position {
  background: #0d6efd;
  color: white;
}
</style>
